import { Link } from "react-router-dom";
import styles from "./PracticeAreas.module.css";
import Reveal from "./Reveal";
import Icon from "./Icons";
import Marquee from "./Marquee";
import { categories, servicesByCategory } from "../data/services";

/* The four pillars, in the order they matter clinically. */
const order = ["physiotherapy", "osteopathy", "oriental", "fitness"];

const blurbs = {
  physiotherapy: {
    icon: "joint",
    text: "Orthopedic, sports, neurological, geriatric, postural and vestibular rehabilitation.",
    accent: "marine",
  },
  osteopathy: {
    icon: "spine",
    text: "Spinal and joint restoration, sciatica relief, craniosacral therapy and manual mobility work.",
    accent: "teal",
  },
  oriental: {
    icon: "moxa",
    text: "Acupuncture, microcurrent, moxibustion, cupping, Gua Sha, IASTM and reflexology.",
    accent: "ember",
  },
  fitness: {
    icon: "strength",
    text: "Clinical strength, functional training, therapeutic yoga, Tai Chi and return-to-sport.",
    accent: "teal",
  },
};

export default function PracticeAreas() {
  return (
    <section className={`u-section ${styles.section}`}>
      <div className="u-shell">
        <Reveal className={styles.head}>
          <p className="u-eyebrow">Core services</p>
          <h2 className={styles.heading}>Four ways of working.</h2>
        </Reveal>

      </div>

      {/* full-bleed sliding row — repeat 2 so one set spans wide
          viewports and the loop stays seamless with only 4 cards */}
      <Marquee speed={58} repeat={2} ariaLabel="Core services">
        {order.map((key) => {
          const cat = categories[key];
          const meta = blurbs[key];
          const count = servicesByCategory(key).length;

          return (
            <Link
              key={key}
              to={`/${cat.slug}`}
              className={styles.card}
              style={{
                "--accent": `var(--a-${meta.accent})`,
                "--accent-wash": `var(--a-${meta.accent}-wash)`,
              }}
            >
              <span className={styles.icon}>
                <Icon name={meta.icon} size={24} />
              </span>

              <h3 className={styles.title}>{cat.label}</h3>
              <p className={styles.text}>{meta.text}</p>

              <span className={styles.foot}>
                <span className={styles.meta}>
                  {count} {count === 1 ? "service" : "services"}
                </span>
                <Icon name="arrow" size={18} className={styles.arrow} />
              </span>
            </Link>
          );
        })}
      </Marquee>
    </section>
  );
}
